export const getFolderNode = (navigationInfo, folderId) =>
  navigationInfo?.foldersById?.[folderId];

export const getDocumentNode = (navigationInfo, documentId) =>
  navigationInfo?.documentsById?.[documentId];

export const getRouteNode = (navigationInfo, { folderId, documentId }) =>
  documentId
    ? getDocumentNode(navigationInfo, documentId)
    : getFolderNode(navigationInfo, folderId);

const isFolderChild = (node) =>
  node.isFolder === true || node.isFolder === "true";

export const getFolderDocuments = (navigationInfo, folderId) =>
  getFolderNode(navigationInfo, folderId)?.children?.filter(
    (child) => !isFolderChild(child)
  );

export const getAllDocuments = (navigationInfo) =>
  Object.values(navigationInfo?.documentsById ?? {});

export const isTargetNode = (node, { folderId, documentId } = {}) => {
  if (documentId !== undefined && documentId !== null) {
    return !!node.isDoc && parseInt(node.vtid) === parseInt(documentId);
  }
  if (folderId !== undefined && folderId !== null) {
    return !node.isDoc && parseInt(node.vtid) === parseInt(folderId);
  }
  return false;
};

export const isEmptyFolderNode = (node) => {
  if (!node?.isFolder || node.isFolder === "false") {
    return false;
  }
  const { leaf, children } = node;
  return !!(
    leaf || children?.filter((c) => c.isFolder !== "true").length === 0
  );
};
